import HeroImage from '../assets/pizzas/Hero.webp';

export const HERO_IMAGE = {
  url: HeroImage,
  alt: 'Frisch gebackene Pizza aus dem Steinofen mit Mozzarella und Basilikum',
};

// Der Hinweis wird automatisch ausgeblendet, sobald das aktuelle Datum "hiddenFrom" erreicht.
export const HERO_NOTICE = {
  title: 'Urlaubszeit',
  greeting: 'Liebe Kundinnen und Kunden,',
  paragraphs: [
    'vom 21. Juli bis einschließlich 5. August gönnen wir uns eine kleine Auszeit. ❤️',
    'Die Sommerferien möchten wir mit unserer Familie und unseren Kindern verbringen – diese gemeinsame Zeit ist für uns etwas ganz Besonderes.',
    'Ab 6. August sind wir wieder mit frischer Energie und leckeren Pizzen für Sie da! 🍕😊',
    'Vielen Dank für Ihr Verständnis und Ihre Treue. Wir freuen uns schon jetzt darauf, Sie nach unserem Urlaub wieder bei uns begrüßen zu dürfen.',
    'Wir wünschen Ihnen ebenfalls einen wunderschönen Sommer! ☀️',
  ],
  signature: 'Ihr Team der Pizzeria ❤️',
  hiddenFrom: '2026-08-06',
};
